import { useDispatch, useSelector } from "react-redux"
import { showModal } from "../redux/actions/ModalActions"
import { Link } from "react-router-dom"
import { useEffect, useState } from "react"
import Loader from "../utils/Loader"
import { hideLoader, showLoader } from "../redux/actions/LoaderActions"
import { toast } from "react-toastify"
import ApiServices from "../config/ApiServices"
import AdminDashboardChart from "../graphs/AdminDashboardChart"


export default function AdminDashboard() {
  const loading = useSelector((state) => state.loader.loading)
  const dispatch = useDispatch()
  const [data, setData] = useState({})
  const [batches, setBatches] = useState([])

  useEffect(() => {
    dispatch(showLoader())
    ApiServices.apiRequest("adminDashboard")
      .then((res) => {
        console.log(res)
        
        if (res.data.success) {
          setData(res.data)
          console.log("admin data is:", res.data)
        } else {
          toast.error(res.data.message)
        }
      })
      .catch((err) => {
        toast.error(err?.message ? err?.message : "Something went wrong")
      })
      .finally(() => {
        dispatch(hideLoader())
      })

    fetchBatch()
  }, [])

  const fetchBatch = () => {
    dispatch(showLoader())
    ApiServices.apiRequest("getBatch")
      .then((result) => {
        if (result.data.success) {
          const activeBatches = result.data.data.filter(
          (batch) => batch.status === true
        )
        setBatches(activeBatches)
        console.log("active batch data is:", activeBatches) 
        }
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        dispatch(hideLoader())
      })
  }

  return (
    <div className="container">
      <div className="page-inner">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4">
              <div>
                <h3 className="fw-bold mb-3">Dashboard</h3>
              </div>
              <div className="ms-md-auto py-2 py-md-0">
                <Link
                  to={"/admin/batches"}
                  className="btn btn-label-info btn-round me-2"
                >
                  Manage
                </Link>
                <button
                  onClick={() => {
                    dispatch(showModal("AddBatch"))
                  }}
                  className="btn btn-primary btn-round"
                >
                  Create Batch
                </button>
              </div>
            </div>

           
            <div className="row">
              <div className="col-sm-6 col-md-4">
                <Link to="/admin/batches">
                  <div className="card card-stats card-round">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-icon">
                          <div className="icon-big text-center icon-primary bubble-shadow-small">
                            <i className="fas fa-layer-group" />
                          </div>
                        </div>
                        <div className="col col-stats ms-3 ms-sm-0">
                          <div className="numbers">
                            <p className="card-category">Batches</p>
                            <h4 className="card-title">{data?.totalBatches}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6 col-md-4">
                <Link to="/admin/students">
                  <div className="card card-stats card-round">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-icon">
                          <div className="icon-big text-center icon-info bubble-shadow-small">
                            <i className="fas fa-user-graduate" />
                          </div>
                        </div>
                        <div className="col col-stats ms-3 ms-sm-0">
                          <div className="numbers">
                            <p className="card-category">Students</p>
                            <h4 className="card-title">{data?.totalStudents}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>

              <div className="col-sm-6 col-md-4">
                <Link to="/admin/trainers">
                  <div className="card card-stats card-round">
                    <div className="card-body">
                      <div className="row align-items-center">
                        <div className="col-icon">
                          <div className="icon-big text-center icon-success bubble-shadow-small">
                            <i className="fas fa-user-tie" />
                          </div>
                        </div>
                        <div className="col col-stats ms-3 ms-sm-0">
                          <div className="numbers">
                            <p className="card-category">Trainers</p>
                            <h4 className="card-title">{data?.totalTrainers}</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>

            <AdminDashboardChart batches={batches} />
          </>
        )}
      </div>
    </div>
  )
}
